export default "__VITE_ASSET__sc054aYx__"